import React from "react";
import Container from "react-bootstrap/Container";
import { Subscribe } from "unstated";
import * as DOMPurify from 'dompurify';
import InvoiceDataContainer from "../../Stores/InvoiceDataContainerStore";
import { myGlobals, myUtilities } from "../../Utils";
import { InvoiceCompleteGridDataRow } from "./";
import { AlertWindow } from "../Common";

class InvoiceCompleteGrid extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLastInvoiceAlert: false,
      showNavigateBackAlert: false,
    };
  }

  generateSelectedIndices = (selectedInvoices, invoices) => {
    let selList = selectedInvoices.map((invoice) => invoice.accountDocHeaderId);
    let invoiceList = invoices.map((invoice) => invoice.accountDocHeaderId);
    let indices = [];

    for (let i = 0; i < invoiceList.length; ++i) {
      if (selList.includes(invoiceList[i])) indices.push(i);
    }

    return indices;
  };

  showLastInvoiceRemovalAlert = () => {
    this.setState(() => ({
      showLastInvoiceAlert: true,
    }));
  };

  showNaviagteBackAlert = () => {
    this.setState(() => ({
      showNavigateBackAlert: true,
    }));
  };

  populateInvoices = (data) => {
    let invoices = data.getInvoices();
    let selectedInvoices = data.getSelectedInvoices();
    let selectedIndices = this.generateSelectedIndices(
      selectedInvoices,
      invoices
    );
    let listItems = new Array();
    const clickHandler = (pos) => {
      if (!data.state.allowInvoiceExclusion) return;

      if (
        myGlobals.checkPaymentContentSelected().localeCompare("SELECTION") !== 0
      ) {
        this.showNaviagteBackAlert();
        return;
      }
      if (!(selectedIndices.includes(pos) && selectedIndices.length === 1)) {
        if (selectedIndices.includes(pos))
          selectedIndices = myUtilities.removeArrayElement(
            selectedIndices,
            pos
          );
        else selectedIndices.push(pos);
      } else this.showLastInvoiceRemovalAlert();

      data.updateSelectedInvoices(selectedIndices.sort());
    };
    for (let i = 0; i < invoices.length; ++i) {
      listItems.push(
        <InvoiceCompleteGridDataRow
          index={i}
          clickHandler={clickHandler}
          selectedIndices={selectedIndices}
          invoiceData={data}
          fields={data.state.gridFields}
          key={invoices[i].invoiceNumber}
        />
      );
    }
    return listItems;
  };
  render() {
    return (
      <Subscribe to={[InvoiceDataContainer]}>
        {(data) => (
          <>
            {this.populateInvoices(data)}
            <Container className="invoice-complete-grid-container">
            {this.state.showLastInvoiceAlert && (
              <AlertWindow
                id="Alert.DeSelectLastInvoice"
                overRideStyle={{ overflow: "hidden" }}
                defaultMessage="Please select atleast one invoice to proceed"
              />
            )}
            {this.state.showNavigateBackAlert && (
              <AlertWindow
                id="Alert.InvoiceRemovalPayment"
                overRideStyle={{ overflow: "hidden" }}
                defaultMessage="Please go back to payment selection page before trying to edit Invoice selection"
              />
            )}
            {data.state.showMissingReasonAlert && (
              <AlertWindow
                id="Alert.MissingPartialPaymentReason"
                overRideStyle={{ overflow: "hidden" }}
                defaultMessage="Please select a reason for making a partial payment."
              />
            )}
            {data.state.showInvalidAmountAlert && (
              <AlertWindow
                id="Alert.InvalidPartialAmountRange"
                overRideStyle={{ overflow: "hidden" }}
                defaultMessage={data.state.invalidAmountAlertMessage}
              />
            )}
            </Container>
          </>
        )}
      </Subscribe>
    );
  }
  componentDidUpdate(prev, next) {
    if (this.state.showLastInvoiceAlert) {
      this.hideLastInvoiceAlert = setTimeout(() => {
        this.setState(() => ({ showLastInvoiceAlert: false }));
      }, 3000);
    }
    if (this.state.showNavigateBackAlert) {
      this.hideNavigateBackAlert = setTimeout(() => {
        this.setState(() => ({ showNavigateBackAlert: false }));
      }, 3000);
    }
  }
  componentWillUnmount() {
    clearTimeout(this.hideLastInvoiceAlert);
    clearTimeout(this.hideNavigateBackAlert);
  }
}
export default InvoiceCompleteGrid;
